export const enum EventType {
  ALL = -1,
  SOCCER = 1,
  TENNIS = 2,
  CRICKET = 4,
  RUGBY_UNION = 5,
  HORSE_RACING = 7,
  E_SOCCER = 137,
  KABADDI = 138,
  GREYHOUND_RACING = 4339,
  AMERICAN_FOOTBALL = 6423,
  BASKETBALL = 7522,
  POLITICS = 2378961,
  ELECTION = 2378962,
  FANCYBET = 9999999,
  VIRTUAL_CRICKET = 11205870
}

export interface EventTypeConst {
  value: EventType
  name: string
  context: string
}

const basicEventTypeConst: Record<Exclude<keyof typeof EventType, "ALL">, EventTypeConst> = Object.freeze({
  SOCCER: {
    name: "SOCCER",
    context: "Soccer",
    value: EventType.SOCCER
  },
  TENNIS: {
    name: "TENNIS",
    context: "Tennis",
    value: EventType.TENNIS
  },
  CRICKET: {
    name: "CRICKET",
    context: "Cricket",
    value: EventType.CRICKET
  },
  RUGBY_UNION: {
    name: "RUGBY_UNION",
    context: "Rugby_Union",
    value: EventType.RUGBY_UNION
  },
  HORSE_RACING: {
    name: "HORSE_RACING",
    context: "Horse Racing",
    value: EventType.HORSE_RACING
  },
  E_SOCCER: {
    name: "E_SOCCER",
    context: "E-Soccer",
    value: EventType.E_SOCCER
  },
  KABADDI: {
    name: "KABADDI",
    context: "kabaddi",
    value: EventType.KABADDI
  },
  GREYHOUND_RACING: {
    name: "GREYHOUND_RACING",
    context: "Greyhound Racing",
    value: EventType.GREYHOUND_RACING
  },
  AMERICAN_FOOTBALL: {
    name: "AMERICAN_FOOTBALL",
    context: "American Football",
    value: EventType.AMERICAN_FOOTBALL
  },
  BASKETBALL: {
    name: "BASKETBALL",
    context: "Basketball",
    value: EventType.BASKETBALL
  },
  POLITICS: {
    name: "POLITICS",
    context: "Politics",
    value: EventType.POLITICS
  },
  ELECTION: {
    name: "ELECTION",
    context: "Election",
    value: EventType.ELECTION
  },
  FANCYBET: {
    name: "FANCYBET",
    context: "FancyBet",
    value: EventType.FANCYBET
  },
  VIRTUAL_CRICKET: {
    name: "VIRTUAL CRICKET",
    context: "Virtual Cricket",
    value: EventType.VIRTUAL_CRICKET
  }
})

const eventTypeConst: Record<keyof typeof EventType, EventTypeConst> = Object.freeze({
  ALL: {
    name: "ALL",
    context: "All",
    value: EventType.ALL
  },
  ...basicEventTypeConst
})

type EventTypeConstMapByValue = Record<EventType, EventTypeConst>

const eventTypeConstMapByValue: EventTypeConstMapByValue = Object.freeze(
  Object.values(eventTypeConst).reduce(
    (acc, cur) => ({
      ...acc,
      [cur.value]: cur
    }),
    {} as EventTypeConstMapByValue
  )
)

export default eventTypeConst
export { eventTypeConstMapByValue, eventTypeConst, basicEventTypeConst }
